import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTourDates } from '../../../../context/TourDateContext';
import { IExpandedTourDate } from '../../models/IExpandedTourDate';
import MobileView from './MobileView';
import WebView from './WebView';

interface Props {
    tourId: number;
}

const TourDetailsResponsive: React.FC<Props> = ({ tourId }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { getAllDates } = useTourDates();

    const dates = getAllDates();

    const groupedByYear = dates.reduce<Record<number, IExpandedTourDate[]>>((acc, date) => {
        if (!acc[date.year]) acc[date.year] = [];
        acc[date.year].push(date);
        return acc;
    }, {});

    if (dates.length === 0) {
        return <Typography variant="body2">Nema dostupnih termina za ovu turu.</Typography>;
    }

    return (
        <Box>
            {Object.entries(groupedByYear).map(([year, yearDates]) => (
                <Box key={`tour-${tourId}-${year}`} sx={{ mb: 4 }}>
                    <Typography variant="h6" gutterBottom mt={1} mb={2}>
                        {`${t("tourDetails.common.terms.termsFor")} ${year}`}.
                    </Typography>

                    {isMobile ? (
                        <MobileView tourDates={yearDates} selectedTourId={tourId} />
                    ) : (
                        <WebView tourDates={yearDates} selectedTourId={tourId} />
                    )}
                </Box>
            ))}
        </Box>
    );
};

export default TourDetailsResponsive;